export const TransactionActionType = {
  LOAD_LIST_START: 'transaction/LOAD_LIST_START',
  LOAD_LIST_SUCCESS: 'transaction/LOAD_LIST_SUCCESS',
  LOAD_LIST_FAILURE: 'transaction/LOAD_LIST_FAILURE',
  SET_LIST_TOTAL: 'transaction/SET_LIST_TOTAL',
  SET_SELECTED: 'transaction/SET_SELECTED',
  SET_ERROR: 'transaction/SET_ERROR',
  CLEAR_ERROR: 'transaction/CLEAR_ERROR',
}

export function createInitialTransactionState() {
  return {
    transactions: [],
    listTotal: 0,
    listPage: 1,
    listLimit: 20,
    selectedTransaction: null,
    listLoading: false,
    error: null,
  }
}

export function transactionReducer(state, action) {
  switch (action.type) {
    case TransactionActionType.LOAD_LIST_START:
      return { ...state, listLoading: true, error: null }
    case TransactionActionType.LOAD_LIST_SUCCESS: {
      const { items, total, page, limit } = action.payload
      return {
        ...state,
        listLoading: false,
        transactions: items,
        listTotal: total,
        listPage: page,
        listLimit: limit,
      }
    }
    case TransactionActionType.LOAD_LIST_FAILURE:
      return { ...state, listLoading: false, error: action.payload }
    case TransactionActionType.SET_LIST_TOTAL:
      return { ...state, listTotal: action.payload }
    case TransactionActionType.SET_SELECTED:
      return { ...state, selectedTransaction: action.payload }
    case TransactionActionType.SET_ERROR:
      return { ...state, error: action.payload, listLoading: false }
    case TransactionActionType.CLEAR_ERROR:
      return { ...state, error: null }
    default:
      return state
  }
}
